export const screenshot = {
    method: 'POST',
    paths: ['/remoteDiagnostic/screenshot'],
    fields: {
        locationName: {
            type: 'keyString',
            required: true,
        },
        locationId: {
            type: 'mongoId',
        },
        format: {
            type: 'keyString',
        },
        screenshot: {
            type: 'longString',
            required: true,
        },
    },
};
//# sourceMappingURL=remote_diagnostic_screenshot.js.map